import * as Yup from 'yup'

export const tenantFormValidationSchema = Yup.object({
  basicDetails: Yup.object({
    name: Yup.string()
      .min(2, 'Enter a name more than 1 characters long')
      .required('This field is required'),
    hostName: Yup.string()
      .required('This field is required')
      .matches(
        /^[a-zA-Z0-9\.][a-zA-Z0-9-\.]{1,61}[a-zA-Z0-9]\.[a-zA-Z]{2,}$/,
        'Enter a valid Address(for example:www.google.com)'
      ),
    slogan: Yup.string().required('This field is required')
  })
  // WBSDetails: Yup.object({
  //   bookingRedirectLink: Yup.string()
  //     .url('Enter a valid address with protocol(for example: https://)')
  //     .required('This field is required')
  // })
})
